// extracted by extract-css-chunks-webpack-plugin
module.exports = {"main_content":"main_content-r5RGqegj"};